const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoctor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 62.35291 59.95472",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M25.72181,35.44209v3.4c0,4.739,4.158,8.223,8.819,8.223h1.295a8.35714,8.35714,0,0,0,8.613-8.223v-14.164m-14.545-8.777a1.02584,1.02584,0,1,1-1.024-1.095A1.06108,1.06108,0,0,1,29.90382,15.90113Zm-6.318,0a1.02584,1.02584,0,1,1-1.024-1.095A1.06108,1.06108,0,0,1,23.58582,15.90113Zm22.365,7.228a1.50268,1.50268,0,1,1-1.502-1.548A1.52607,1.52607,0,0,1,45.95081,23.1291Zm2.307,0a3.81074,3.81074,0,1,1-3.809-3.926A3.869,3.869,0,0,1,48.25781,23.1291Zm-18.354-7.202c3.058.822,5.158,2.801,5.158,6.713,0,5.522-4.182,12.802-9.34,12.802-5.159,0-9.341-7.28-9.341-12.802,0-3.912,2.1-5.891,5.158-6.713",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctor);
export default __webpack_public_path__ + "static/media/doctor.a214cfe0b909cdce0608475f349914c0.svg";
export { ForwardRef as ReactComponent };